import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  isDevMode
} from "@angular/core";
import { CurrentUser } from "@common/auth/current-user";
import { Modal } from "@common/core/ui/dialogs/modal.service";
import { CustomDomainService } from "@common/custom-domain/custom-domain.service";
import { UserDomainsService } from "src/app/dashboard/user-domains.service";

import { Settings } from "@common/core/config/settings.service";
import { copyToClipboard } from "@common/core/utils/copy-link-to-clipboard";
import { CustomDomain } from "@common/custom-domain/custom-domain";
import { ProjectUrl } from "../../../project-url.service";
import { Projects } from "../../../projects.service";
import { ProjectSettingsService } from "../../project-settings.service";
import { Unsub } from "src/app/unsub.class";
import { takeUntil } from "rxjs/operators";

interface ITextCopied {
  customDomain: boolean;
  domainName: boolean;
  aRecord: boolean;
  dnsRecordName: boolean;
  cloudFrontRecordName: boolean;
  dnsRecordType: boolean;
  cloudFrontRecordType: boolean;
  cloudFrontRecordValue: boolean;
  cName: boolean;
}
interface CrupdateCustomDomainModalData {
  domain: CustomDomain;
  resourceName: string;
}
@Component({
  selector: "dns-settings",
  templateUrl: "./dns-settings.component.html",
  styleUrls: ["./dns-settings.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DnsSettingsComponent extends Unsub implements OnInit {
  constructor(
    private modal: Modal,
    public projectSettings: ProjectSettingsService,
    private customDomains: CustomDomainService,
    private projects: Projects,
    public settings: Settings,
    public projectUrl: ProjectUrl,
    public userDomains: UserDomainsService,
    public currentUser: CurrentUser,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    super();
  }

  editModeIsEnabled = false;
  panelOpenState = false;
  agreeToDnsSettings = false;
  showLoader = false;
  nameServerList = [];

  textIsCopied: ITextCopied = {
    customDomain: false,
    domainName: false,
    dnsRecordName: false,
    cloudFrontRecordName: false,
    cloudFrontRecordValue: false,
    dnsRecordType: false,
    cloudFrontRecordType: false,
    aRecord: false,
    cName: false,
  };
  showProgressBar: boolean = false;

  get showWebsitePulishedSuccessfuly() {
    return (
      this.projectSettings.project.isSSLConfigured == 1 &&
      this.projectSettings.project.ssl_exipre_date != null &&
      this.projectSettings.project.website_publish_status == 1 &&
      this.projectSettings.project.final_distribution_update_status ==
        "success" &&
      this.projectSettings.project.final_distribution_status == "Deployed"
    );
  }
  get showWebsitePulishedInProgress() {
    return (
      this.projectSettings.project.final_distribution_update_status ==
      "InProgress" && this.projectSettings.project.website_publish_status == 1
    );
  }
  get showWebsitePulishedFinally() {
    return this.projectSettings.project.website_publish_status == 1;
  }
  get showCloudFrontIsSuccessful() {
    return this.projectSettings.project.cloudfront_status == "Deployed";
  }
  get showDistributionIsInProgress() {
    return this.projectSettings.project.cloudfront_status == "InProgress";
  }
  get sslAndProvisionProgressStatus() {
    let status = false;
    if (this.showSSLIsInProgress && this.showDistributionIsInProgress) {
      status = true;
    } else if (this.showSSLIsInProgress && this.showCloudFrontIsSuccessful) {
      status = true;
    } else if (this.showSSLIsSuccess && this.showDistributionIsInProgress) {
      status = true;
    }
    return status;
  }

  get showSSLIsInProgress() {
    return (
      this.projectSettings.project.dns_update_status == 1 &&
      this.projectSettings.project.isSSLConfigured == 0
    );
  }
  get shouldShowButton() {
    let status = false;
    if (
      this.projectSettings.project.isSSLConfigured == 0 &&
      this.projectSettings.project.cloudfront_status == null
    ) {
      status = true;
    } else if (
      this.projectSettings.project.isSSLConfigured == 1 &&
      this.projectSettings.project.cloudfront_status == "Deployed" &&
      this.projectSettings.project.dns_update_status == 1 &&
      this.projectSettings.project.website_publish_status == 0
    ) {
      status = true;
    }
    return status;
  }
  get enablePublishDomain() {
    return (
      this.projectSettings.project.dns_update_status == 1 &&
      this.projectSettings.project.isSSLConfigured == 1 &&
      this.projectSettings.project.cloudfront_status == "Deployed"
    );
  }
  get showSSLIsSuccess() {
    return this.projectSettings.project.isSSLConfigured == 1;
  }
  get showCopyDnsSection() {
    return (
      this.projectSettings.project.dns_update_status == 0 && this.hasRecords
    );
  }

  ngOnInit(): void {
    this.projectSettings.loading.pipe(takeUntil(this.unsubscribe$)).subscribe((data) => {
      this.showLoader = data;
      console.log("loader changed", data);
      this.changeDetectorRef.detectChanges();
    });
    this.nameServerList =
      this.projectSettings.project.name_servers
        ? JSON.parse(this.projectSettings.project.name_servers).map((item) => {
            return {
              title: item,
              isActive: false,
            };
          })
        : [];
  }

  toggleCheckbox(status: boolean) {
    this.agreeToDnsSettings = status;
  }

  onClickedCopy(url: string, key: string) {
    console.log(url);

    this.textIsCopied[key] = !this.textIsCopied[key];
    copyToClipboard(url);
  }
  onClickedCopyNameServer(
    item: { title: string; isActive: boolean },
    index: number
  ) {
    console.log(item.title);
    this.nameServerList.forEach((element, ind) => {
      if (ind == index) {
        element.isActive = true;
      } else {
        element.isActive = false;
      }
    });
    copyToClipboard(item.title);
  }
  get hasRecords(): boolean {
    return this.projectSettings.project.domain_name != null;
  }
  get checkIsDevMode() {
    return isDevMode();
  }

  getImagePath(key: string) {
    return this.textIsCopied[key]
      ? `${!this.checkIsDevMode ? "client/" : ""}assets/img/copied.png`
      : `${!this.checkIsDevMode ? "client/" : ""}assets/img/copy.png`;
  }
  getImagePathForNameServer(item: { title: string; isActive: boolean }) {
    return item.isActive
      ? `${!this.checkIsDevMode ? "client/" : ""}assets/img/copied.png`
      : `${!this.checkIsDevMode ? "client/" : ""}assets/img/copy.png`;
  }
}
